import NavBar from '../components/NavBar';
import LandingCard from '../components/LandingCard';
import Footer from '../components/Footer';

import clientImg from '../assets/clientmanagement.png';
import followUpImg from '../assets/follow-up.png';
import historyImg from '../assets/interaction-history.png';
import aiImg from '../assets/ai.png';

import {Navigate, useNavigate} from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import React from 'react';
import HowItWorks from "../components/HowItWorks";
import PricingTeaser from "../components/PricingTeaser";

function LandingPage() {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    return (
        isAuthenticated ? <Navigate to="/dashboard" /> :
            <div id="landing-page" className="min-h-screen flex flex-col bg-white text-gray-800">
                <NavBar />

                {/* ── Hero ── */}
                <section className="relative overflow-hidden text-center py-24 px-4 bg-gradient-to-b from-blue-50 to-white">
                    {/* subtle decorative blobs */}
                    <div className="pointer-events-none absolute -top-24 -left-24 w-96 h-96 rounded-full bg-blue-100 opacity-40 blur-3xl" />
                    <div className="pointer-events-none absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-orange-100 opacity-40 blur-3xl" />

                    <p className="text-crumborange font-semibold tracking-widest uppercase text-sm mb-3">
                        Simple CRM for real work
                    </p>
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-crumbblue mb-6 leading-tight">
                        Every client, every follow-up,<br className="hidden sm:block" /> all in one place.
                    </h1>
                    <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto">
                        CrumbCRM is built for freelancers, contractors, and small business owners who don't have
                        time for bloated software. Track clients, log interactions, and never miss a follow-up — free to start.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        <button
                            className="bg-crumborange text-white font-semibold py-3 px-8 rounded-full hover:bg-orange-600 transition shadow-md text-base"
                            onClick={() => navigate('signup')}
                        >
                            Get started for free
                        </button>
                        <a
                            href="#how-it-works"
                            className="text-crumbblue font-semibold py-3 px-8 rounded-full border-2 border-crumbblue hover:bg-blue-50 transition text-base"
                        >
                            See how it works
                        </a>
                    </div>
                    <p className="text-xs text-gray-400 mt-4">No credit card required.</p>
                </section>

                {/* ── Features ── */}
                <section className="max-w-6xl mx-auto px-4 py-20">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-crumbblue mb-3">Everything you need. Nothing you don't.</h2>
                        <p className="text-gray-500 max-w-xl mx-auto">
                            Stop juggling spreadsheets, sticky notes, and email threads. CrumbCRM keeps it all tidy.
                        </p>
                    </div>
                    <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                        <LandingCard
                            imageSrc={clientImg}
                            title="Client Management"
                            description="Add individual clients or businesses with attached contacts. All their details, notes, and history in one place."
                        />
                        <LandingCard
                            imageSrc={followUpImg}
                            title="Follow-up Reminders"
                            description="Schedule follow-ups and get reminders on your dashboard and client pages. No client ever falls through the cracks."
                        />
                        <LandingCard
                            imageSrc={historyImg}
                            title="Interaction History"
                            description="Log calls, emails, and meetings with file attachments. Always know exactly where you left off with every client."
                        />
                        <LandingCard
                            imageSrc={aiImg}
                            title="AI Summaries"
                            description="Long notes? Let AI distill them into a quick summary so you can stay focused on the work that matters."
                        />
                    </div>
                </section>

                {/* ── How It Works ── */}
                <HowItWorks />

                {/* ── Pricing Teaser ── */}
                <PricingTeaser onSignUp={() => navigate('signup')} />

                {/* ── Final CTA ── */}
                <section className="bg-crumbblue text-white text-center py-20 px-4">
                    <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to get organized?</h2>
                    <p className="text-blue-100 mb-8 max-w-xl mx-auto">
                        Start for free — no credit card, no commitment. Add your first client in under a minute.
                    </p>
                    <button
                        className="bg-crumborange text-white font-semibold py-3 px-8 rounded-full hover:bg-orange-500 transition shadow-lg text-base"
                        onClick={() => navigate('signup')}
                    >
                        Create your free account
                    </button>
                </section>

                <Footer />
            </div>
    );
}

export default LandingPage;